import { Controller } from "@hotwired/stimulus"

// Рядок форми тарифів за місяць: чекбокс «Не застосовується» блокує та очищає
// поле тарифу. connect() синхронізує стан для передзаповнених «не застосовується»
// і для перерендеру після 422.
export default class extends Controller {
  static targets = ["value", "checkbox"]

  connect() {
    this.sync()
  }

  toggle() {
    this.sync({ focusOnEnable: true })
  }

  sync({ focusOnEnable = false } = {}) {
    if (!this.hasValueTarget || !this.hasCheckboxTarget) return

    if (this.checkboxTarget.checked) {
      this.valueTarget.value = ""
      this.valueTarget.disabled = true
    } else {
      this.valueTarget.disabled = false
      if (focusOnEnable) this.valueTarget.focus()
    }
  }
}
